const dashboard = {
  namespaced: true,

  state() {
    return {
      isPageLoaded: false,
    };
  },

  mutations: {
    setIsLoadedPage(state, loadedPage) {
      state.isPageLoaded = loadedPage;
    },
  },

  actions: {},
};
export default dashboard;
